export const CommitSeal = ({ play }) => (
  <svg
    width="48"
    height="16"
    viewBox="0 0 48 16"
    fill="none"
    aria-hidden="true"
    focusable="false"
    data-testid="commit-seal"
    className="block text-ax-brand"
    style={{ visibility: play ? "visible" : "hidden" }}
  >
    <style>{`
      .seal-a, .seal-b { stroke-dasharray: 20; stroke-dashoffset: ${play ? 20 : 0}; }
      .seal-a { animation: seal 240ms ease-out forwards; }
      .seal-b { animation: seal 240ms ease-out 240ms forwards; }
      @keyframes seal { to { stroke-dashoffset: 0; } }
      @media (prefers-reduced-motion: reduce) {
        .seal-a, .seal-b { animation: none; stroke-dashoffset: 0; }
      }
    `}</style>
    <path className="seal-a" d="M2 8H22" stroke="#0D9488" strokeWidth="2" />
    <path className="seal-b" d="M46 8H26" stroke="currentColor" strokeWidth="2" />
    <path d="M24 4L28 8L24 12L20 8L24 4Z" fill="currentColor" />
  </svg>
);
